import React from 'react'

import { BOOKING, BookingContext } from './BookingContext'
import { fetchBooking } from '../helpers/hotelHelper'
import { MBooking } from '../types'
import { prettifyDate } from '../../common/helpers/general'
import {
  getBookingStatus,
  isBookingCancellable,
  getBookingStatusColor
} from '../helpers/bookingHelper'

import {
  isNotPriceApplicableUser
} from '../helpers/userHelper'

const BookingItem = ({ booking }) => {
  const { state, dispatch } = React.useContext(BookingContext)

  const __getBooking = async (payload) => {
    dispatch({ type: BOOKING.LOADING, payload: true })
    const data = await fetchBooking(payload)

    if (data && data.booking) {
      dispatch({ type: BOOKING.LOADING, payload: false })
      dispatch({ type: BOOKING.SET, payload: data.booking })
    }
  }

  const _selectBookingForCancellation = (e, booking) => {
    e.stopPropagation()
    dispatch({ type: BOOKING.CANCELLATION.SET, payload: booking })
  }

  const active = state.booking && state.booking.id === booking.id

  return (
    <div className={`item row ${active && 'active'}`}>
      <div className="booking-list-item" onClick={() => __getBooking(booking)}>
        <div className="booking-list-item-container">
          <div className="booking-details">
            <span className="title">
              {booking.property} in {booking.destination}
            </span>
            <span className="gray">
              {booking.first_name} {booking.last_name}
            </span>
            <span className="gray">
              {prettifyDate(booking.arrival)} to {prettifyDate(booking.departure)}
            </span>
            {booking.lodging_confirmation_code && (
              <span className="gray code"><strong>Confirmation Code:</strong> {booking.lodging_confirmation_code}</span>
            )}
            {booking.tour_confirmation_code && (
              <span className="gray code"><strong>Tour ID:</strong> {booking.tour_confirmation_code}</span>
            )}
          </div>
          {!isNotPriceApplicableUser(state.user) && (
            <div className="pull-right price">
              <em>Price</em>
              <strong>${Math.ceil(booking.package_price)}</strong>
            </div>)
          }
        </div>

        <hr />

        <div className="actions">
          <span className={`status-badge alert ${getBookingStatusColor(booking.status)}`}>{getBookingStatus(booking)}</span>
          {!isNotPriceApplicableUser(state.user) && isBookingCancellable(booking) && <a onClick={(e) => _selectBookingForCancellation(e, booking)} className="button basic cancel-booking">Cancel</a>}
        </div>
      </div>
    </div>
  )
}

BookingItem.propTypes = {
  booking: MBooking.isRequired,
}

export default BookingItem
